// extracted by mini-css-extract-plugin
module.exports = {"--size-5x":"40px","size5X":"40px","root":"root-3xhqg0xiZQ"};